import type { ComponentProps } from 'react';

import type { DataExplorerViewItemProps } from './types';
import { DataExplorerViewItemShell } from './DataExplorerViewItemShell';

export function DataExplorerViewItem<TItem = unknown, TContext = unknown>(
  props: DataExplorerViewItemProps<TItem, TContext>,
) {
  const { item, index, itemId, context, capabilities, itemDefinition, className, selected, actions, onOpen, onSelectionChange } =
    props;

  if (itemDefinition?.render) {
    return <>{itemDefinition.render(props)}</>;
  }

  const resolvedShellProps =
    typeof itemDefinition?.shellProps === 'function'
      ? itemDefinition.shellProps({
          item,
          index,
          itemId,
          context,
          capabilities,
          itemDefinition,
          className,
          selected,
          actions,
          onOpen,
          onSelectionChange,
        })
      : itemDefinition?.shellProps;

  return (
    <DataExplorerViewItemShell
      {...(resolvedShellProps as Partial<ComponentProps<typeof DataExplorerViewItemShell>> | undefined)}
      className={className}
    />
  );
}
